import { render, staticRenderFns } from "./ImagePreviewDialog.vue?vue&type=template&id=54626b44&scoped=true"
import script from "./ImagePreviewDialog.vue?vue&type=script&lang=js"
export * from "./ImagePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewDialog.vue?vue&type=style&index=0&id=54626b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54626b44",
  null
  
)

export default component.exports